import { Textarea as ChakraTextarea, TextareaProps } from '@chakra-ui/react';

import {
  FormFieldUncontrolledComponent,
  FormFieldUncontrolledComponentProps,
} from '../../types/fields';

export const Textarea: FormFieldUncontrolledComponent<TextareaProps> = ({
  _ref,
  ...props
}: FormFieldUncontrolledComponentProps<TextareaProps>) => (
  <ChakraTextarea ref={_ref} id={props.name} {...props} />
);

Textarea.controlled = false;
Textarea.displayName = 'Textarea';
